import { render, staticRenderFns } from "./IF-Notes.vue?vue&type=template&id=5d941700&scoped=true&"
import script from "./IF-Notes.vue?vue&type=script&lang=js&"
export * from "./IF-Notes.vue?vue&type=script&lang=js&"
import style0 from "./IF-Notes.vue?vue&type=style&index=0&id=5d941700&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d941700",
  null
  
)

export default component.exports